var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExternal = function SvgExternal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.526.5h-5.445a.968.968 0 0 0-.964.964c0 .53.435.964.964.964h3.1l-9.018 9.038a.959.959 0 0 0 0 1.361.96.96 0 0 0 1.361 0l9.038-9.019V6.91c0 .53.435.964.964.964.53 0 .965-.434.965-.964V1.464A.968.968 0 0 0 17.526.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.03 9.444a.968.968 0 0 0-.964.964v3.876a2.255 2.255 0 0 1-2.25 2.25h-7.09a2.255 2.255 0 0 1-2.25-2.25v-7.09a2.255 2.255 0 0 1 2.25-2.25H8.6c.53 0 .965-.435.965-.965a.968.968 0 0 0-.965-.964H4.725A4.2 4.2 0 0 0 .528 7.213v7.09A4.2 4.2 0 0 0 4.725 18.5h7.09a4.2 4.2 0 0 0 4.198-4.197v-3.895a.997.997 0 0 0-.983-.964Z"
  })));
};
export default SvgExternal;